import { ValueFunction } from '../../index';

function addTwoNumbers({a = null, b = null}) {
  if (a !== null || b !== null) {
    return a+b;
  } else {
    return null;
  }
}

export const add = new ValueFunction(
  addTwoNumbers,
  {
    label: 'Add Two Series',
    description: 'a + b',
    parameters: [
      {'name': 'a', 'type': 'number'},
      {'name': 'b', 'type': 'number'}
    ],
    maxLength: 2
  }
);